import Session from './session'

export default class LeaveRequestAPI {

  static get PREFIX () {
    return Session.HOST + '/api/leave_request/'
  }

  /**
   * 休暇申請取得
   */
  static get (date) {
    const s = new Session()
    return s.ins.post(this.PREFIX + 'get/' + date)
  }

  /**
   * 休暇申請登録
   */
  static create (body) {
    const s = new Session()
    return s.ins.post(this.PREFIX + 'create', body)
  }

  /**
   * 休暇申請削除
   * @param {String} userId ユーザID
   * @param {YYYY-MM-DD} date 対象日
   */
  static delete (userId, date) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + 'delete/' + userId + '/' + date)
  }

  /**
   * 休暇一覧取得
   */
  static getYukyuList (params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'list', {params: params})
  }

  /**
   * 特別休暇の申請状況一覧取得
   */
  static getSpLeaveSummary(params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'list/getSpLeaveSummary', { params: params })
  }

  

  /**
   * 年一覧取得
   */
  static getYearList () {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'year/list')
  }

  /**
   * 未承認の有給一覧取得
   */
  static getUnapprovedYukyuList () {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'list/unapproved')
  }

  /**
   * 有給日数管理一覧取得
   */
  static getYukyuManageList () {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'management/list')
  }

  /**
   * 有給管理簿一覧取得
   */
  static getYukyuControlBook (params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'controlbook/list', {params: params})
  }

  /**
   * 有給ステータス更新
   */
  static updateStatus (status, userId, targetDate) {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'status-update/' + status + '/' + userId + '/' + targetDate)
  }

  /**
   * 有給ステータス一括更新
   */
  static bulkStatusUpdate (status, data) {
    const s = new Session()
    let body= {
      keyList : data
    }
    return s.ins.post(this.PREFIX + 'status-bulk-update/' + status, body)
  }

  /**
   * アップロード
   */
  static upload (data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + 'upload', data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/api/leave-request-api.js